/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorNotFound } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
// @ts-ignore
import type { FormulaCalculationResponse } from '../models';
// @ts-ignore
import type { PPPMaterialWeightBatchRequest } from '../models';
// @ts-ignore
import type { PPPMaterialWeightBatchResponse } from '../models';
// @ts-ignore
import type { PPPMaterialWeightRequest } from '../models';
// @ts-ignore
import type { PPPPaperDimensionRequest } from '../models';
/**
 * CalculationServicePrintPaperPackagingPublishingApi - axios parameter creator
 */
export const CalculationServicePrintPaperPackagingPublishingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate print, paper, packaging & publishing emissions by weight of the product
         * @param {PPPMaterialWeightRequest} pPPMaterialWeightRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pppMaterialWeight: async (pPPMaterialWeightRequest: PPPMaterialWeightRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pPPMaterialWeightRequest' is not null or undefined
            assertParamExists('pppMaterialWeight', 'pPPMaterialWeightRequest', pPPMaterialWeightRequest)
            const localVarPath = `/calculation/v1/calculate/ppp/weight`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pPPMaterialWeightRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate print, paper, packaging & publishing emissions by weight of the product in a batch
         * @param {PPPMaterialWeightBatchRequest} pPPMaterialWeightBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pppMaterialWeightBatch: async (pPPMaterialWeightBatchRequest: PPPMaterialWeightBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pPPMaterialWeightBatchRequest' is not null or undefined
            assertParamExists('pppMaterialWeightBatch', 'pPPMaterialWeightBatchRequest', pPPMaterialWeightBatchRequest)
            const localVarPath = `/calculation/v1/calculate/ppp/weight/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pPPMaterialWeightBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate paper emissions by dimensions of the product
         * @param {PPPPaperDimensionRequest} pPPPaperDimensionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pppPaperDimension: async (pPPPaperDimensionRequest: PPPPaperDimensionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pPPPaperDimensionRequest' is not null or undefined
            assertParamExists('pppPaperDimension', 'pPPPaperDimensionRequest', pPPPaperDimensionRequest)
            const localVarPath = `/calculation/v1/calculate/ppp/dimension`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pPPPaperDimensionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationServicePrintPaperPackagingPublishingApi - functional programming interface
 */
export const CalculationServicePrintPaperPackagingPublishingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationServicePrintPaperPackagingPublishingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Calculate print, paper, packaging & publishing emissions by weight of the product
         * @param {PPPMaterialWeightRequest} pPPMaterialWeightRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pppMaterialWeight(pPPMaterialWeightRequest: PPPMaterialWeightRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pppMaterialWeight(pPPMaterialWeightRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServicePrintPaperPackagingPublishingApi.pppMaterialWeight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate print, paper, packaging & publishing emissions by weight of the product in a batch
         * @param {PPPMaterialWeightBatchRequest} pPPMaterialWeightBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pppMaterialWeightBatch(pPPMaterialWeightBatchRequest: PPPMaterialWeightBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PPPMaterialWeightBatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pppMaterialWeightBatch(pPPMaterialWeightBatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServicePrintPaperPackagingPublishingApi.pppMaterialWeightBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate paper emissions by dimensions of the product
         * @param {PPPPaperDimensionRequest} pPPPaperDimensionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pppPaperDimension(pPPPaperDimensionRequest: PPPPaperDimensionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pppPaperDimension(pPPPaperDimensionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServicePrintPaperPackagingPublishingApi.pppPaperDimension']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculationServicePrintPaperPackagingPublishingApi - factory interface
 */
export const CalculationServicePrintPaperPackagingPublishingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationServicePrintPaperPackagingPublishingApiFp(configuration)
    return {
        /**
         * 
         * @summary Calculate print, paper, packaging & publishing emissions by weight of the product
         * @param {CalculationServicePrintPaperPackagingPublishingApiPppMaterialWeightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pppMaterialWeight(requestParameters: CalculationServicePrintPaperPackagingPublishingApiPppMaterialWeightRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.pppMaterialWeight(requestParameters.pPPMaterialWeightRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate print, paper, packaging & publishing emissions by weight of the product in a batch
         * @param {CalculationServicePrintPaperPackagingPublishingApiPppMaterialWeightBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pppMaterialWeightBatch(requestParameters: CalculationServicePrintPaperPackagingPublishingApiPppMaterialWeightBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<PPPMaterialWeightBatchResponse> {
            return localVarFp.pppMaterialWeightBatch(requestParameters.pPPMaterialWeightBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate paper emissions by dimensions of the product
         * @param {CalculationServicePrintPaperPackagingPublishingApiPppPaperDimensionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pppPaperDimension(requestParameters: CalculationServicePrintPaperPackagingPublishingApiPppPaperDimensionRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.pppPaperDimension(requestParameters.pPPPaperDimensionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for pppMaterialWeight operation in CalculationServicePrintPaperPackagingPublishingApi.
 */
export interface CalculationServicePrintPaperPackagingPublishingApiPppMaterialWeightRequest {
    readonly pPPMaterialWeightRequest: PPPMaterialWeightRequest
}

/**
 * Request parameters for pppMaterialWeightBatch operation in CalculationServicePrintPaperPackagingPublishingApi.
 */
export interface CalculationServicePrintPaperPackagingPublishingApiPppMaterialWeightBatchRequest {
    readonly pPPMaterialWeightBatchRequest: PPPMaterialWeightBatchRequest
}

/**
 * Request parameters for pppPaperDimension operation in CalculationServicePrintPaperPackagingPublishingApi.
 */
export interface CalculationServicePrintPaperPackagingPublishingApiPppPaperDimensionRequest {
    readonly pPPPaperDimensionRequest: PPPPaperDimensionRequest
}

/**
 * CalculationServicePrintPaperPackagingPublishingApi - object-oriented interface
 */
export class CalculationServicePrintPaperPackagingPublishingApi extends BaseAPI {
    /**
     * 
     * @summary Calculate print, paper, packaging & publishing emissions by weight of the product
     * @param {CalculationServicePrintPaperPackagingPublishingApiPppMaterialWeightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pppMaterialWeight(requestParameters: CalculationServicePrintPaperPackagingPublishingApiPppMaterialWeightRequest, options?: RawAxiosRequestConfig) {
        return CalculationServicePrintPaperPackagingPublishingApiFp(this.configuration).pppMaterialWeight(requestParameters.pPPMaterialWeightRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate print, paper, packaging & publishing emissions by weight of the product in a batch
     * @param {CalculationServicePrintPaperPackagingPublishingApiPppMaterialWeightBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pppMaterialWeightBatch(requestParameters: CalculationServicePrintPaperPackagingPublishingApiPppMaterialWeightBatchRequest, options?: RawAxiosRequestConfig) {
        return CalculationServicePrintPaperPackagingPublishingApiFp(this.configuration).pppMaterialWeightBatch(requestParameters.pPPMaterialWeightBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate paper emissions by dimensions of the product
     * @param {CalculationServicePrintPaperPackagingPublishingApiPppPaperDimensionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pppPaperDimension(requestParameters: CalculationServicePrintPaperPackagingPublishingApiPppPaperDimensionRequest, options?: RawAxiosRequestConfig) {
        return CalculationServicePrintPaperPackagingPublishingApiFp(this.configuration).pppPaperDimension(requestParameters.pPPPaperDimensionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

